import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type MergeCarrierMutationVariables = Types.Exact<{
  input: Types.MergeCarrierInput;
}>;


export type MergeCarrierMutation = { __typename?: 'Mutation', mergeCarrier: { __typename?: 'LogisticsCarrierPayload', carrier?: { __typename?: 'LogisticsCarrierStateData', tenantId: string, carrierId: string, name: string, type: Types.CarrierType, contactName: string, contactEmail: string, contactPhone: string, dotNumber: string, mcNumber: string, isActive: boolean, notes: string, rateBasis: Types.CarrierRateBasis, rateAmount?: number | null, fuelSurchargePercent?: number | null, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteCarrierMutationVariables = Types.Exact<{
  input: Types.DeleteCarrierInput;
}>;


export type DeleteCarrierMutation = { __typename?: 'Mutation', deleteCarrier: { __typename?: 'LogisticsCarrierPayload', carrier?: { __typename?: 'LogisticsCarrierStateData', tenantId: string, carrierId: string, name: string, type: Types.CarrierType, contactName: string, contactEmail: string, contactPhone: string, dotNumber: string, mcNumber: string, isActive: boolean, notes: string, rateBasis: Types.CarrierRateBasis, rateAmount?: number | null, fuelSurchargePercent?: number | null, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type LogisticsCarrierStateFieldsFragment = { __typename?: 'LogisticsCarrierStateData', tenantId: string, carrierId: string, name: string, type: Types.CarrierType, contactName: string, contactEmail: string, contactPhone: string, dotNumber: string, mcNumber: string, isActive: boolean, notes: string, rateBasis: Types.CarrierRateBasis, rateAmount?: number | null, fuelSurchargePercent?: number | null, updatedAt: Types.TDateISO, updatedBy: string };

export const LogisticsCarrierStateFieldsFragmentDoc = new TypedDocumentString(`
    fragment LogisticsCarrierStateFields on LogisticsCarrierStateData {
  tenantId
  carrierId
  name
  type
  contactName
  contactEmail
  contactPhone
  dotNumber
  mcNumber
  isActive
  notes
  rateBasis
  rateAmount
  fuelSurchargePercent
  updatedAt
  updatedBy
}
    `, {"fragmentName":"LogisticsCarrierStateFields"});
export const MergeCarrierDocument = new TypedDocumentString(`
    mutation MergeCarrier($input: MergeCarrierInput!) {
  mergeCarrier(input: $input) {
    carrier {
      ...LogisticsCarrierStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment LogisticsCarrierStateFields on LogisticsCarrierStateData {
  tenantId
  carrierId
  name
  type
  contactName
  contactEmail
  contactPhone
  dotNumber
  mcNumber
  isActive
  notes
  rateBasis
  rateAmount
  fuelSurchargePercent
  updatedAt
  updatedBy
}`);
export const DeleteCarrierDocument = new TypedDocumentString(`
    mutation DeleteCarrier($input: DeleteCarrierInput!) {
  deleteCarrier(input: $input) {
    carrier {
      ...LogisticsCarrierStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment LogisticsCarrierStateFields on LogisticsCarrierStateData {
  tenantId
  carrierId
  name
  type
  contactName
  contactEmail
  contactPhone
  dotNumber
  mcNumber
  isActive
  notes
  rateBasis
  rateAmount
  fuelSurchargePercent
  updatedAt
  updatedBy
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    MergeCarrier: build.mutation<MergeCarrierMutation, MergeCarrierMutationVariables>({
      query: (variables) => ({ document: MergeCarrierDocument, variables })
    }),
    DeleteCarrier: build.mutation<DeleteCarrierMutation, DeleteCarrierMutationVariables>({
      query: (variables) => ({ document: DeleteCarrierDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useMergeCarrierMutation, useDeleteCarrierMutation } = injectedRtkApi;
